(() => {
  if (customElements.get('product-a-plus')) return;

  customElements.define('product-a-plus', class extends HTMLElement {
    connectedCallback() {
      this.onNavigation = event => {
        const previous = event.target.closest('.product-a-plus__previous');
        const next = event.target.closest('.product-a-plus__next');
        const carousel = this.querySelector('carousel-element')?.carousel;
        if (!carousel?.isActive) return;
        if (previous) carousel.previous();
        if (next) carousel.next();
      };
      this.onSlideChange = event => {
        this.querySelectorAll('.product-a-plus__item').forEach((item, index) => {
          if (index !== event.detail.index) {
            item.querySelectorAll('video').forEach(video => video.pause());
          }
        });
      };
      this.addEventListener('click', this.onNavigation);
      this.addEventListener('carousel:change', this.onSlideChange);
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onNavigation);
      this.removeEventListener('carousel:change', this.onSlideChange);
      this.querySelectorAll('video').forEach(video => video.pause());
    }
  });
})();
